import { useEffect, useMemo, type ReactNode } from 'react';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { createAppTheme } from './createAppTheme';
import { useThemeModeStore } from './themeModeStore';
import { FONT_SCALE_VALUE, useFontScaleStore } from './fontScaleStore';

interface Props {
  children: ReactNode;
}

const BASE_HTML_FONT_SIZE = 16;

export function AppThemeProvider({ children }: Props) {
  const mode = useThemeModeStore((state) => state.mode);
  const scale = useFontScaleStore((state) => state.scale);
  const scaleValue = FONT_SCALE_VALUE[scale];
  const theme = useMemo(() => createAppTheme(mode), [mode]);

  // Skalowanie czcionki: ustawiamy `font-size` na <html>. MUI używa rem we wszystkich
  // variantach (h1..h6, body1, button itd.), więc całość kaskaduje. Browser-natywne
  // skalowanie czcionki (Ctrl/Cmd +) działa równolegle — nie konfliktuje.
  useEffect(() => {
    document.documentElement.style.fontSize = `${BASE_HTML_FONT_SIZE * scaleValue}px`;
    return () => {
      document.documentElement.style.fontSize = '';
    };
  }, [scaleValue]);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
}
